exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js!./iconfont/iconfont.css"), "");

// module
exports.push([module.id, "html,body{margin:0;padding:0;background:#e9e9e9}.main{position:relative;width:100%;height:100%;margin:0 auto}.main .content{position:relative;max-width:793px;height:100%;margin:10px auto 30px;font-size:0}", ""]);

// exports
